/* ==========================================================================
   DIREVULF — loader.js
   Global + per-fandom loading overlay.
   The overlay is decoration on top of an already-usable page. It can never
   delay, block or replace content, and it removes itself unconditionally.

   Whether it shows at all is decided inline in snippets/loader.liquid, right
   after its markup, so it is up before the page behind it first paints (the
   once-per-session, Save-Data/2G and reduced-motion rules live there). This
   file only takes it down:
     - once the page has loaded, and
     - for the brand ignition, not before its 1.4s pass has finished, so a
       fast page still sees the whole short sequence rather than a cut-off
       flash (it is shown once per session, never on every page);
     - at a hard ceiling whatever happens;
     - at once on a click or Escape.
   ========================================================================== */
(function () {
  'use strict';

  var el = document.querySelector('[data-dv-loader]');

  /* A plain click on a link to the home page, from any other page, marks the
     navigation so the home page shows the loader before it first paints
     (snippets/loader.liquid). Modified clicks, new tabs, downloads and links
     to the page already open are ignored, so an active Home link never
     replays it. One listener per page. */
  if (el && !window.__dvHomeLoaderClick) {
    window.__dvHomeLoaderClick = true;
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || url.pathname !== ROOT) return;
      if (location.pathname === ROOT) return;
      try { window.sessionStorage.setItem('dv:loader:to-home', String(Date.now())); } catch (err) {}
    }, true);

    /* Coming back to a page from the back/forward cache: never leave an
       overlay standing over it. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      el.hidden = true;
      el.classList.remove('is-leaving');
    });
  }

  if (!el || el.hidden) return;

  var IGNITION_MS = 1450;
  var animated = el.classList.contains('dv-loader--ignite') && !el.classList.contains('is-static');

  var maxMs = parseInt(el.getAttribute('data-max-ms'), 10);
  if (isNaN(maxMs) || maxMs < 200) maxMs = 1200;
  /* Never cut the ignition off part-way. */
  if (animated) maxMs = Math.max(maxMs, 2000);

  var shownAt = parseInt(el.getAttribute('data-dv-shown'), 10);
  if (isNaN(shownAt)) shownAt = Date.now();

  var dismissed = false;
  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    el.classList.add('is-leaving');
    window.setTimeout(function () {
      el.hidden = true;
      el.classList.remove('is-leaving');
    }, 240);
  }

  /* Hard ceiling, measured from when the overlay actually appeared. */
  window.setTimeout(dismiss, Math.max(0, shownAt + maxMs - Date.now()));

  var loaded = document.readyState === 'complete';

  function litAt() {
    var v = parseInt(el.getAttribute('data-dv-lit'), 10);
    return isNaN(v) ? null : v;
  }

  function check() {
    if (dismissed || !loaded) return;
    if (!animated) { window.setTimeout(dismiss, 200); return; }
    var lit = litAt();
    if (lit === null) return;
    var left = lit + IGNITION_MS - Date.now();
    if (left <= 0) dismiss();
    else window.setTimeout(check, left);
  }

  if (!loaded) {
    window.addEventListener('load', function () { loaded = true; check(); }, { once: true });
  }

  if (animated && litAt() === null) {
    /* Lit a moment later (logo still arriving): re-check when it is. */
    var watch = new MutationObserver(function () {
      if (litAt() !== null) { watch.disconnect(); check(); }
    });
    watch.observe(el, { attributes: true, attributeFilter: ['data-dv-lit'] });
  }

  check();

  /* Escape or any interaction dismisses it immediately - it must never trap. */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(); });
  el.addEventListener('click', dismiss);
})();
